<div class="error-container">
    <img class="error-container__icon" src="assets/images/smiley-in-trouble.svg" alt="Error image" />
    <span class="error-container__message">{{ 'error.message' | translate }}</span>
</div>
